export default __webpack_public_path__ + "static/media/icon-transation-send-light.7c72c702.svg";